import { useSelector } from 'react-redux';

import { renderModel } from '../../util/renderModel';
import { TRootState } from '../reducers';

export const CARA_REFERRAL = 'cara';
const CARA_SESSION_ID_PARAMS = ['kera_session_id', 'cara_session_id'];

const isCaraSessionFromUrl = (): boolean => {
  const params = renderModel.getQueryParams() ?? {};

  if (params.referral === CARA_REFERRAL) {
    return true;
  }

  return CARA_SESSION_ID_PARAMS.some((key) => {
    const value = params[key];
    return typeof value === 'string' && value.trim() !== '';
  });
};

export const getIsCaraSession = (state: TRootState): boolean =>
  state.widget.caraSessionInConversation || isCaraSessionFromUrl();

export const useIsCaraSession = (): boolean => useSelector(getIsCaraSession);
